<script setup lang="ts">
import { Form } from "@inertiajs/vue3"
import { ref } from "vue"

import FormField from "@/components/custom/FormField.vue"
import { Button } from "@/components/ui/button"
import { Card, CardContent } from "@/components/ui/card"
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog"
import { Input } from "@/components/ui/input"
import { cn } from "@/lib/utils"
import { managerAppSettingPath } from "@/routes"
import type { ManagerSettingsStudySetting } from "@/types/serializers"

defineProps<{
  setting: ManagerSettingsStudySetting
}>()

const open = ref(false)
</script>

<template>
  <Dialog v-model:open="open">
    <DialogTrigger>
      <slot />
    </DialogTrigger>
    <DialogContent>
      <DialogHeader>
        <DialogTitle :class="cn('font-bold')">
          Solicitud / {{ setting.name }}
        </DialogTitle>
        <DialogDescription>
          Revisión de reembolso de educación
        </DialogDescription>
      </DialogHeader>
      <Card>
        <CardContent>
          <Form
            :action="managerAppSettingPath(setting.id)"
            method="put"
            class="flex flex-col gap-4"
            #default="{ errors }"
            @success="open = false"
          >
            <input name="id" :value="setting.id" hidden />
            <FormField
              name="max_amount"
              label="Límite de reembolso"
              :errors="errors.max_amount"
              required
            >
              <Input
                name="max_amount"
                type="number"
                step="0.01"
                :default-value="setting.max_amount"
              />
            </FormField>

            <Button type="submit">Guardar</Button>
          </Form>
        </CardContent>
      </Card>
    </DialogContent>
  </Dialog>
</template>
